import React, { useState } from 'react';

const ImageUpload = ({ onImagesChange }) => {
  const [images, setImages] = useState([]);

  const handleChange = (e) => {
    const files = Array.from(e.target.files);

    if (files.length + images.length > 4) {
      alert("You can only upload up to 4 images.");
      return;
    }

    const validFiles = [];
    const newImages = [];

    files.forEach((file) => {
      if (file.size > 840 * 1024) { // 640KB size limit
        alert(`${file.name} is too large. Maximum size is 640KB.`);
      } else {
        validFiles.push(file);
        newImages.push(URL.createObjectURL(file));
      }
    });

    if (newImages.length > 0) {
      setImages(prevImages => [...prevImages, ...newImages]);
      onImagesChange(validFiles);
    }
  };

  return (
    <div>
      <label htmlFor='image'
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600
         dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
      >
        <svg data-slot="icon" 
          fill="none" stroke-width="2"
          stroke="currentColor"
          viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
          className='w-5 h-5 inline-block mr-2'>
          <path stroke-linecap="round" stroke-linejoin="round" d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"></path>
        </svg>
        <span className='inline-block '>{images.length > 0 ? `${images.length} File${images.length > 1 ? 's' : ''} Chosen` : "Choose File"}</span>
      </label>
      <input
        id='image'
        name="image"
        type="file"
        accept="image/*"
        multiple
        onChange={handleChange}
        className="hidden"
      />
    </div>
  );
};

export default ImageUpload;
